import { Component, Input, OnInit, Output } from "@angular/core";
import { Subject } from "rxjs";
import { BasicActionsEventType } from "./basic-actions-event-type";


@Component({
  selector: "app-subscription-actions",
  templateUrl: "./subscription-actions.component.html",
  styleUrls: ['./subscription-actions.component.scss']
})
export class SubscriptionActionsComponent implements OnInit {
  constructor() {}

  @Output()
  emitter = new Subject<BasicActionsEventType>();

  @Input()
  data = {};

  ngOnInit(): void {
  }

  onAction2(event) {
    event.stopPropagation()
    this.emitter.next({
      cmd: "cancel",
      data: this.data,
    });
  }

  ngOnDestroy() {
    this.emitter.unsubscribe();
  }
}